<ng-select [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [compareWith]="$any(compareWith)"
    [class.readonly]="readonly"
    [clearable]="clearable"
    [clearSearchOnAdd]="clearSearchOnAdd"
    [closeOnSelect]="closeOnSelect"
    [dropdownPosition]="$any(dropdownPosition)"
    [formControl]="formControl"
    [hideSelected]="hideSelected"
    [items]="dropdown"
    [loading]="loading"
    [minTermLength]="minTermLength"
    [multiple]="multiple"
    [ngClass]="ngSelectClass"
    [placeholder]="placeholder"
    [readonly]="_readonly"
    [typeahead]="search$"
    [typeToSearchText]="typeToSearchText | translate"
    [notFoundText]="notFoundText | translate"
    [appendTo]="appendTo"
    [addTag]="addTag"
    [addTagText]="addTagText"
    [class.is-invalid]="invalid"
    [notFoundText]="'SELECT.No items found'|translate"
    (change)="onSelect($event)"
    (close)="onClose()"
    (search)="onSearchChange($event)"
    (open)="onOpen()">
  <ng-container *ngIf="optionContent">
    <ng-template let-item="item"
        ng-option-tmp>
      <ng-container *ngTemplateOutlet="optionContent.templateRef; context: { $implicit: item }">
      </ng-container>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="multiLabelContent">
    <ng-template ng-multi-label-tmp
        let-clear="clear"
        let-items="items">
      <ng-container *ngTemplateOutlet="multiLabelContent.templateRef; context: { $implicit: items, clear: clear }">
      </ng-container>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="labelContent">
    <ng-template let-item="item"
        ng-label-tmp>
      <ng-container *ngTemplateOutlet="labelContent.templateRef; context: { $implicit: item }">
      </ng-container>
    </ng-template>
  </ng-container>
</ng-select>